<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  template=" <img src='assets/images/spinner.gif' />"
></ngx-spinner>

<!-- <div class="content-top-box">
  <ul class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
      <a
        class="breadcrumb-link"
        [routerLink]="breadcrumItem.Url"
        [id]="breadcrumItem.id"
        (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)"
      >
        {{ breadcrumItem.text }}
      </a>
    </li>
  </ul>
</div> -->

<div class="content">
  <ul class="breadcrumb">
    <li class="breadcrumb-item">
      <a class="breadcrumb-link" routerLink="/Access">Access</a>
    </li>
  </ul>    
  <div class="header-title">
    <h1 class="main-title">
      {{ "View Licenses by Module" }}
    </h1>
  </div>
  <form name="HeaderForm" [formGroup]="HeaderForm" class="w-100 m-10">
    <div class="w-100 headerForm d-flex">
      <mat-form-field appearence="fill" class="w-27">
        <mat-label>
          {{ "Group" }}
        </mat-label>
        <mat-select formControlName="group" (selectionChange)="filterData()">
          <input
            (keyup)="onGroupKey($event.target)"
            (change)="onGroupKey('')"
            class="form-control w-100"
            placeholder="Search Group"
          />
          <!-- <mat-option value="-1"></mat-option> -->
          <mat-option *ngFor="let group of GroupList" [value]="group.id">
            {{ group.name }}
          </mat-option>
        </mat-select>
        <mat-error>Group is required</mat-error>
      </mat-form-field>

      <div style="margin-top: 20px"></div>
    </div>
  </form>
</div>

<div style="margin-top: 20px">
  <ag-grid-angular
    style="width: 100%"
    class="ag-theme-alpine"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [domLayout]="domLayout"
    (gridReady)="onGridReady($event)"
    (cellClicked)="cellClicked($event)"
    [gridOptions]="gridOptions"
    [pagination]="true"
    [paginationPageSize]="20"
    [frameworkComponents]="frameworkComponents"
    [suppressRowClickSelection]="true"
  ></ag-grid-angular>
</div>

<ng-template #groupLicensePopup>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">User License Info</h1>
      <button
        mat-mini-fab
        mat-button
        mat-dialog-close
        color="warn"
        title="close"
      >
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <ag-grid-angular
    style="width: 100%; height: 35vw"
    class="ag-theme-alpine"
    [rowData]="popupRowData"
    [columnDefs]="popupColumnDefs"
    [domLayout]="domLayout"
    (gridReady)="onGridReady($event)"
    (cellClicked)="cellClicked($event)"
    [gridOptions]="gridOptions"
    [pagination]="true"
    [paginationPageSize]="20"
    [frameworkComponents]="frameworkComponents"
    [suppressRowClickSelection]="true"
  ></ag-grid-angular>
</ng-template>
